module.exports = __webpack_public_path__ + "static/media/404-error.a9d51937.png";